import { WorkspacesProvider } from './WorkspacesContext';

const WorkspacesProviderWrapper = ({ children }) => (
  <WorkspacesProvider>{children}</WorkspacesProvider>
);

export default WorkspacesProviderWrapper;
